export default __webpack_public_path__ + "static/media/Level19.11391bb5.svg";